import Vue from 'vue';

export default {
    upload(data) {
        return Vue.axios.post('imageUpload/upload', data);
    }
};
